import { api } from "../../service/api";
import { CardActionType } from "./action-type";

const initialState = {
}

const cardReducer = (state = initialState, action) => {
    const request = action.payload;
    if (action.type === CardActionType.SEND_PROPOSAL_CARD_BENEFIT) {
        api.post('/api/Cartao/beneficio/gravar-proposta', request, res => {
            action.callBack(res.data);
        }, err => {
            if (err.mensagem === "Endereço do cliente não cadastrado.") {
                action.errCallBack()
            }
        })
    }
    if (action.type === CardActionType.SEND_PROPOSAL_CARD_BMG) {
        api.post('/api/Cartao/bmg-card/gravar-proposta', request, res => {
            action.callBack(res.data);
        }, err => {
            if (err.mensagem === "Endereço do cliente não cadastrado.") {
                action.errCallBack()
            }
        })
    }
    if (action.type === CardActionType.SEND_PROPOSAL_CARD_MASTER) {
        api.post('/api/Cartao/master/gravar-proposta', request, res => {
            action.callBack(res.data);
        }, err => {
            if (err.mensagem === "Endereço do cliente não cadastrado.") {
                action.errCallBack()
            }
        })
    }

    return state;
}

export default cardReducer;